/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Input_Position_Box_TitleInputs */



/**
* | output |
* | --- |
* | "Position: {position}" |
*
* @param {Input_Position_Box_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_box_title = /** @type {((inputs: Input_Position_Box_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Box_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Position : ${i?.position}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Position: ${i?.position}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Posizione: ${i?.position}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Должность: ${i?.position}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Posición: ${i?.position}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`位置：${i?.position}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ポジション: ${i?.position}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्थिति: ${i?.position}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Posição: ${i?.position}`)
	return /** @type {LocalizedString} */ (`Position: ${i?.position}`)
});